export default "__VITE_ASSET__bfa9fb2d__"